var _mask, _path, _path2, _mask2, _path3, _path4, _mask3, _path5, _path6, _mask4, _path7, _path8, _mask5, _path9, _path0, _mask6, _path1, _path10, _mask7, _path11, _path12, _mask8, _path13, _path14, _mask9, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWheelError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 203,
    viewBox: "0 0 203 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_596_4506",
    maskUnits: "userSpaceOnUse",
    x: 5.99999,
    y: 99.334,
    width: 154,
    height: 103,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 5.99999,
    y: 99.334,
    width: 154,
    height: 103
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.961 184.209C145.369 192.712 131.005 198.234 115.959 200.355C100.913 202.476 85.5824 201.14 71.1302 196.45C56.678 191.76 43.4847 183.837 32.5521 173.285C21.6196 162.733 13.2355 149.829 8.03636 135.551L102 101.334L157.961 184.209Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.961 184.209C145.369 192.712 131.005 198.234 115.959 200.355C100.913 202.476 85.5824 201.14 71.1302 196.45C56.678 191.76 43.4847 183.837 32.5521 173.285C21.6196 162.733 13.2355 149.829 8.03636 135.551L102 101.334L157.961 184.209Z",
    fill: "#29C18C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.961 184.209C145.369 192.712 131.005 198.234 115.959 200.355C100.913 202.476 85.5824 201.14 71.1302 196.45C56.678 191.76 43.4847 183.837 32.5521 173.285C21.6196 162.733 13.2355 149.829 8.03636 135.551L102 101.334L157.961 184.209Z",
    stroke: "white",
    strokeWidth: 2,
    mask: "url(#path-1-outside-1_596_4506)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-2_596_4506",
    maskUnits: "userSpaceOnUse",
    x: 102,
    y: 99.334,
    width: 97,
    height: 87,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 102,
    y: 99.334,
    width: 97,
    height: 87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.317 184.175C177.619 171.427 191.151 152.614 197.675 130.849L105.079 101.315L159.317 184.175Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M159.317 184.175C177.619 171.427 191.151 152.614 197.675 130.849L105.079 101.315L159.317 184.175Z",
    fill: "#E9ADCA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159.317 184.175C177.619 171.427 191.151 152.614 197.675 130.849L105.079 101.315L159.317 184.175Z",
    stroke: "white",
    strokeWidth: 2,
    mask: "url(#path-2-outside-2_596_4506)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-3_596_4506",
    maskUnits: "userSpaceOnUse",
    x: 102,
    y: 46.334,
    width: 101,
    height: 86,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 102,
    y: 46.334,
    width: 101,
    height: 86
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.668 130.873C201.777 117.175 202.982 102.727 201.201 88.5072C199.421 74.2875 194.696 60.6291 187.348 48.4586L105.079 101.315L197.668 130.873Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M197.668 130.873C201.777 117.175 202.982 102.727 201.201 88.5072C199.421 74.2875 194.696 60.6291 187.348 48.4586L105.079 101.315L197.668 130.873Z",
    fill: "#CCA3CF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M197.668 130.873C201.777 117.175 202.982 102.727 201.201 88.5072C199.421 74.2875 194.696 60.6291 187.348 48.4586L105.079 101.315L197.668 130.873Z",
    stroke: "white",
    strokeWidth: 2,
    mask: "url(#path-3-outside-3_596_4506)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-4_596_4506",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 17.334,
    width: 100,
    height: 86,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 5,
    y: 17.334,
    width: 100,
    height: 86
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4744 19.5366C26.9227 31.8802 13.8069 49.542 7.06474 69.9128L102 101.334L44.4744 19.5366Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4744 19.5366C26.9227 31.8802 13.8069 49.542 7.06474 69.9128L102 101.334L44.4744 19.5366Z",
    fill: "#E25297"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4744 19.5366C26.9227 31.8802 13.8069 49.542 7.06474 69.9128L102 101.334L44.4744 19.5366Z",
    stroke: "white",
    strokeWidth: 2,
    mask: "url(#path-4-outside-4_596_4506)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-outside-5_596_4506",
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 4.33398,
    width: 60,
    height: 98,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 43,
    y: 4.33398,
    width: 60,
    height: 98
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7213 19.3635C53.3973 13.301 62.9807 8.65432 73.1137 5.59693L102 101.334L44.7213 19.3635Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7213 19.3635C53.3973 13.301 62.9807 8.65432 73.1137 5.59693L102 101.334L44.7213 19.3635Z",
    fill: "#F79A00"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7213 19.3635C53.3973 13.301 62.9807 8.65432 73.1137 5.59693L102 101.334L44.7213 19.3635Z",
    stroke: "white",
    strokeWidth: 2,
    mask: "url(#path-5-outside-5_596_4506)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-outside-6_596_4506",
    maskUnits: "userSpaceOnUse",
    x: 71.5381,
    y: 0.333978,
    width: 33,
    height: 102,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 71.5381,
    y: 0.333978,
    width: 33,
    height: 102
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6265 5.52177C83.2342 2.70017 93.2135 1.28936 103.241 1.33506L102.769 101.334L73.6265 5.52177Z"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6265 5.52177C83.2342 2.70017 93.2135 1.28936 103.241 1.33506L102.769 101.334L73.6265 5.52177Z",
    fill: "#99439D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6265 5.52177C83.2342 2.70017 93.2135 1.28936 103.241 1.33506L102.769 101.334L73.6265 5.52177Z",
    stroke: "white",
    strokeWidth: 2,
    mask: "url(#path-6-outside-6_596_4506)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-outside-7_596_4506",
    maskUnits: "userSpaceOnUse",
    x: -0.00000580519,
    y: 67.334,
    width: 109,
    height: 71,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -0.00000580519,
    y: 67.334,
    width: 109,
    height: 71
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.82795 70.6374C0.0384788 91.6876 0.419383 114.395 7.9111 135.205L102 101.334L6.82795 70.6374Z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82795 70.6374C0.0384788 91.6876 0.419383 114.395 7.9111 135.205L102 101.334L6.82795 70.6374Z",
    fill: "#86BB00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82795 70.6374C0.0384788 91.6876 0.419383 114.395 7.9111 135.205L102 101.334L6.82795 70.6374Z",
    stroke: "white",
    strokeWidth: 4,
    mask: "url(#path-7-outside-7_596_4506)"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-outside-8_596_4506",
    maskUnits: "userSpaceOnUse",
    x: 102.458,
    y: 0.33398,
    width: 60,
    height: 105,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 102.458,
    y: 0.33398,
    width: 60,
    height: 105
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.307 1.33398C124.59 1.33398 144.353 8.00366 160.77 20.3891L104.307 101.316L104.307 1.33398Z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M104.307 1.33398C124.59 1.33398 144.353 8.00366 160.77 20.3891L104.307 101.316L104.307 1.33398Z",
    fill: "#F79A00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M104.307 1.33398C124.59 1.33398 144.353 8.00366 160.77 20.3891L104.307 101.316L104.307 1.33398Z",
    stroke: "white",
    strokeWidth: 2,
    mask: "url(#path-8-outside-8_596_4506)"
  })), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-outside-9_596_4506",
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 18.2969,
    width: 88,
    height: 84,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 101,
    y: 18.2969,
    width: 88,
    height: 84
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.611 20.2737C171.204 27.9367 180.192 37.6026 187.065 48.7243L102 101.297L160.611 20.2737Z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M160.611 20.2737C171.204 27.9367 180.192 37.6026 187.065 48.7243L102 101.297L160.611 20.2737Z",
    fill: "#F5CC3B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M160.611 20.2737C171.204 27.9367 180.192 37.6026 187.065 48.7243L102 101.297L160.611 20.2737Z",
    stroke: "white",
    strokeWidth: 2,
    mask: "url(#path-9-outside-9_596_4506)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M102 180.797C145.907 180.797 181.5 145.204 181.5 101.297C181.5 57.3902 145.907 21.7969 102 21.7969C58.0934 21.7969 22.5 57.3902 22.5 101.297C22.5 145.204 58.0934 180.797 102 180.797Z",
    fill: "#F6F7F9",
    stroke: "white",
    strokeWidth: 3
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M101.972 73.2969C86.516 73.2969 74 85.8409 74 101.297C74 116.753 86.516 129.297 101.972 129.297C117.456 129.297 130 116.753 130 101.297C130 85.8409 117.456 73.2969 101.972 73.2969ZM102 123.697C89.624 123.697 79.6 113.673 79.6 101.297C79.6 88.9209 89.624 78.8969 102 78.8969C114.376 78.8969 124.4 88.9209 124.4 101.297C124.4 113.673 114.376 123.697 102 123.697ZM99.2 109.697H104.8V115.297H99.2V109.697ZM99.2 87.2969H104.8V104.097H99.2V87.2969Z",
    fill: "#BBBBBB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelError);
export default __webpack_public_path__ + "static/media/wheelError.bb3f19e473af8cd7ed0eeb10490787b3.svg";
export { ForwardRef as ReactComponent };